<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/X9zOdk/tc-custom/9781952225468.jpg?1737678473723" alt="This image is the cover for the book Out of the Mouths of Serial Killers"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Out of the Mouths of Serial Killers
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Learn why serial killers kill through their own words—including Ted Bundy, Jeffrey Dahmer, the BTK Killer, Aileen Wuornos, and more than 70 others.  </b></p><p>In this one-of-a-kind book, author Mary Brett corresponded with some of America’s most evil convicted serial killers and asked just one question: WHY? Their return letters give an insightful look into the dark mind of each killer. The reader also will be able to scrutinize direct quotes, unedited, from interrogation statements, trial testimony, media interviews, and parole hearing inquests</p> Seventy-five serial killers are included in the book, some only known to the unfortunate victims’ family, friends, and community, while others are the most infamous in the annals of serial killers. All bios feature the crime, the capture, the victims, and background facts. Crime scene photos, some graphic, are featured.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mary Brett
      </h2>
      
      <p class="authorDescription body article">Mary Brett holds a BFA from Virginia Commonwealth University in Richmond, VA. She currently lives in the Tampa Bay area of Florida with her partner, dog, bird, and 3 cats. OUT OF THE MOUTHS OF SERIAL KILLERS is her fourth book.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      WildBlue Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?9043ab96